import React from 'react';
import PropTypes from 'prop-types';
import { Layer, Box, Anchor } from 'wt-ui';
import { Close } from 'grommet-icons';
import ProductsTable from '../ProductsTable';
import UpcomingEvents from '../UpcomingEvents';

const ProductLayer = ({ product, ...rest }) => (
  <Layer {...rest}>
    <Box background="transparent" pad="medium" width="600px" style={{ minHeight: '250px' }}>
      <Anchor href="#" onClick={rest.onEsc} style={{ position: 'absolute', right: '10px', top: '10px' }}>
        <Close />
      </Anchor>
      <ProductsTable underlying={product.name} assetClass={product.assetClass} />
      <UpcomingEvents underlying={product.name} />
    </Box>
  </Layer>
);
ProductLayer.propTypes = {
  product: PropTypes.shape({}).isRequired,
};

export default ProductLayer;
